import request from '../utils/request'

const prefix = '/api/v1/back'



/**
 * 关联
 */
export const refCreateChapterLevel2 = (query) => {
  return request({
    url: `${prefix}/readChapter/refCreateChapterLevel2`,
    method: 'post',
    data: query
  })
}

/**
 * 复制
 */
export const copyCreateChapterLevel2 = (query) => {
  return request({
    url: `${prefix}/readChapter/copyCreateChapterLevel2`,
    method: 'post',
    data: query
  })
}

/**
 * 专栏审核
 */

export const auditStatus = (query) => {
  return request({
    url: `${prefix}/read/auditStatus`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料查询：列表
 * @param {*} query
 */
export const readList = (query) => {
  return request({
    url: `${prefix}/read/list`,
    method: 'get',
    params: query
  })
}

/**
 * 阅读资料查询
 * @param {*} query
 */
export const readOne = (query) => {
  return request({
    url: `${prefix}/read`,
    method: 'get',
    params: query
  })
}

/**
 * 阅读资料创建
 * @param {*} query
 */
export const readCreate = (query) => {
  return request({
    url: `${prefix}/read`,
    method: 'post',
    data: query
  })
}

/**
 * 阅读资料修改
 * @param {*} query
 */
export const readUpdate = (query) => {
  return request({
    url: `${prefix}/read`,
    method: 'put',
    data: query
  })
}

/**
 * 实体资料修改 多行
 * @param {*} query
 */
export const readsUpdate = (query) => {
  return request({
    url: `${prefix}/reads`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料修改状态
 * @param {*} query
 */
export const readUpdateStatus = (query) => {
  return request({
    url: `${prefix}/read/status`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料删除
 * @param {*} query
 */
export const readDestroy = (query) => {
  return request({
    url: `${prefix}/read`,
    method: 'delete',
    data: query
  })
}

/**
 * 阅读资料删除 真
 * @param {*} query
 */
export const readRemove = (query) => {
  return request({
    url: `${prefix}/read/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 阅读资料恢复
 * @param {*} query
 */
export const readRestore = (query) => {
  return request({
    url: `${prefix}/read/restore`,
    method: 'post',
    data: query
  })
}

/**
 * 阅读资料克隆
 * @param {*} query
 */
export const readClone = (query) => {
  return request({
    url: `${prefix}/read/clone`,
    method: 'post',
    data: query
  })
}

/**
 * 阅读资料章节查询：列表
 * @param {*} query
 */
export const readChapterList = (query) => {
  return request({
    url: `${prefix}/readChapter/list`,
    method: 'get',
    params: query
  })
}

/**
 * 阅读资料章节查询
 * @param {*} query
 */
export const readChapterOne = (query) => {
  return request({
    url: `${prefix}/readChapter`,
    method: 'get',
    params: query
  })
}

/**
 * 阅读资料章节创建
 * @param {*} query
 */
export const readChapterCreate = (query) => {
  return request({
    url: `${prefix}/readChapter`,
    method: 'post',
    data: query
  })
}

/**
 * 阅读资料章节修改
 * @param {*} query
 */
export const readChapterUpdate = (query) => {
  return request({
    url: `${prefix}/readChapter`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料章节修改 多行
 * @param {*} query
 */
export const readChaptersUpdate = (query) => {
  return request({
    url: `${prefix}/readChapters`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料章节状态修改
 * @param {*} query
 */
export const readChapterUpdateStatus = (query) => {
  return request({
    url: `${prefix}/readChapter/status`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料章节删除
 * @param {*} query
 */
export const readChapterDestroy = (query) => {
  return request({
    url: `${prefix}/readChapter`,
    method: 'delete',
    data: query
  })
}

/**
 * 阅读资料试卷详情
 * @param {*} query
 */
export const readPaperOne = (query) => {
  return request({
    url: `${prefix}/readPaper`,
    method: 'get',
    params: query
  })
}

/**
 * 阅读资料试卷修改
 * @param {*} query
 */
export const readPaperUpdate = (query) => {
  return request({
    url: `${prefix}/readPaper`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料试卷知识点查询：列表
 * @param {*} query
 */
export const readPaperItemList = (query) => {
  return request({
    url: `${prefix}/readItem/list`,
    method: 'get',
    params: query
  })
}

/**
 * 阅读资料试卷知识点创建
 * @param {*} query
 */
export const readPaperItemCreate = (query) => {
  return request({
    url: `${prefix}/readPaper/item`,
    method: 'post',
    data: query
  })
}

/**
 * 阅读资料试卷知识点修改
 * @param {*} query
 */
export const readPaperItemUpdate = (query) => {
  return request({
    url: `${prefix}/readPaper/item`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料试卷知识点修改 多条
 * @param {*} query
 */
export const readPaperItemsUpdate = (query) => {
  return request({
    url: `${prefix}/readPaper/items`,
    method: 'put',
    data: query
  })
}

/**
 * 阅读资料试卷知识点删除
 * @param {*} query
 */
export const readPaperItemDestroy = (query) => {
  return request({
    url: `${prefix}/readPaper/item`,
    method: 'delete',
    data: query
  })
}

/**
 * 阅读资料知识点修改
 * @param {*} query
 */
export const readItemUpdate = (query) => {
  return request({
    url: `${prefix}/readItem`,
    method: 'put',
    data: query
  })
}

/**
 * 分类管理列表
 * @param {*} query
 */
export const readcategorylist = (query) => {
  return request({
    url: `${prefix}/read/category/list`,
    method: 'get',
    data: query
  })
}
/**
 * 分类创建
 * @param {*} query
 */
export const readCategoryCreate = (query) => {
  return request({
    url: `${prefix}/read/category`,
    method: 'post',
    data: query
  })
}

/**
 * 分类修改
 * @param {*} query
 */
export const readCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/read/category`,
    method: 'put',
    data: query
  })
}

/**
 * 获取专栏预同布信息接口
 * @param {*} query
 * 
 */
export const productPrePublishInfo = (query) => {
  return request({
    url: `${prefix}/note/productPrePublishInfo`,
    method: 'get',
    params: query
  })
}
/**
 * 虚拟用户列表
 * @param {*} query
 * 
 */

export const userIdentityList = (query) => {
  return request({
    url: `${prefix}/note/userIdentity/list`,
    method: 'get',
    params: query
  })
}
/**
 * 同步笔记专栏创建
 * @param {*} query
 * 
 */
export const noteCreate = (query) => {
  return request({
    url: `${prefix}/note`,
    method: 'post',
    data: query
  })
}

/**
 *  笔记上传附件
 * @param {*} query
 * 
 */

export const byNotePdf = (query) => {
  return request({
    url: `${prefix}/upload/private/byNotePdf`,
    method: 'post',
    data: query
  })
}
/**
 *  笔记上传视频
 * @param {*} query
 * 
 */

// export const byNotePdf = (query) => {
//   return request({
//     url: `${prefix}/upload/private/byNotePdf`,
//     method: 'post',
//     data: query
//   })
// }
/**
 * 文件上传（单个私有获取解密地址）
 * 
 */
export const uploadprivatesign = (query) => {
  return request({
    url: `${prefix}/upload/private/sign`,
    method: 'post',
    data: query
  })
}





